import { render } from "./AllIncubators.vue?vue&type=template&id=652c41bd&scoped=true"
import script from "./AllIncubators.vue?vue&type=script&lang=js"
export * from "./AllIncubators.vue?vue&type=script&lang=js"

import "./AllIncubators.vue?vue&type=style&index=0&id=652c41bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652c41bd"]])

export default __exports__